import React from "react";
import { Card, Typography, Space, Button, Tooltip, message } from "antd";
import { FileTextOutlined, ExportOutlined, CopyOutlined } from "@ant-design/icons";
import type { SignPageComponentModel } from "@services/api";

const { Title, Paragraph } = Typography;

interface Props {
  signPage?: SignPageComponentModel;
  className?: string;
}

// Копирование «как в antd»: через временный <textarea> + document.execCommand('copy')
function copyTextLegacy(text: string): boolean {
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);

    const selection = document.getSelection();
    const selectedRange = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

    ta.select();
    const ok = document.execCommand("copy");

    if (selectedRange && selection) {
      selection.removeAllRanges();
      selection.addRange(selectedRange);
    }

    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

export default function SignDocsCard({ signPage, className }: Props) {
  const url = signPage?.attributes?.externalTaskUrl?.trim();

  // Если ссылки нет — не показываем компонент совсем
  if (!url || url === '-') return null;

  const openInNewTab = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const copyToClipboard = async () => {
    const ok = copyTextLegacy(url);
    if (ok) message.success("Ссылка скопирована");
    else message.error("Не удалось скопировать ссылку");
  };

  return (
    <Card className={className} bordered bodyStyle={{ padding: 20 }}>
      {/* Заголовок */}
      <Space align="center" size={8} style={{ marginBottom: 8 }}>
        <FileTextOutlined style={{ color: "#1677ff", fontSize: 20 }} />
        <Title level={5} style={{ margin: 0 }}>Необходимо подписать документы</Title>
      </Space>

      {/* Текст + действия */}
      <Space direction="vertical" size={10} style={{ width: "100%" }}>
        <Paragraph type="secondary" style={{ margin: 0 }}>
          Отправьте клиенту ссылку для подписания документов
        </Paragraph>

        <Space size={12} wrap>
          <Tooltip title="Открыть в новой вкладке">
            <Button type="primary" icon={<ExportOutlined />} onClick={openInNewTab}>
              Открыть страницу подписи
            </Button>
          </Tooltip>
          <Tooltip title="Скопировать ссылку">
            <Button icon={<CopyOutlined />} onClick={copyToClipboard}>
              Скопировать ссылку
            </Button>
          </Tooltip>
        </Space>
      </Space>
    </Card>
  );
}
